import React, { useState } from "react";

const LayoutTab =  ({ updateFileEmbedTabData,fileEmbedTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [activeLayoutType, setActiveLayoutType] = useState(fileEmbedTabData.layout_type);
    const [isShowFileIcon, setIsShowFileIcon] = useState(Number(fileEmbedTabData.is_show_file_icon));
    const [previewImageSize, setPreviewImageSize] = useState(fileEmbedTabData.preview_image_width);
    const [isShowDownloadLink, setIsShowDownloadLink] = useState(Number(fileEmbedTabData.is_show_download_link));
    const [downloadLinkText, setDownloadLinkText] = useState(fileEmbedTabData.download_link_text);
    const [width, setWidth] = useState(fileEmbedTabData.width);
    const [heightWidthRatio, setHeightWidthRatio] = useState(fileEmbedTabData.height_width_ratio);

    // Handle Layout Type input change
    const handleActiveLayoutTypeChange = (event) => {
        setActiveLayoutType(event.target.value);
        updateFileEmbedTabData("layout_type", event.target.value);
    };

    //Handle Show File Icon toggle
    const handleIsShowFileIconToggle = (e) => {
        const checked = e.target.checked;
        setIsShowFileIcon(checked);
        updateFileEmbedTabData('is_show_file_icon', checked);
    };

    // Handlers Preview Image Size Change
    const handlePreviewImageSizeChange = (e) => {
        const value = e.target.value;
        setPreviewImageSize(value);
        updateFileEmbedTabData("preview_image_width", value);
    };

    //Handle Show Download Link toggle
    const handleIsShowDownloadLinkToggle = (e) => {
        const checked = e.target.checked;
        setIsShowDownloadLink(checked);
        updateFileEmbedTabData('is_show_download_link', checked);
    };

    //Handlers Download Link Text Change
    const handleDownloadLinkTextChange = (e) => {
        const value = e.target.value;
        setDownloadLinkText(value);
        updateFileEmbedTabData("download_link_text", value); 
    };

    //Handlers Width Change
    const handleWidthChange = (e) => {
        const value = e.target.value;
        setWidth(value);
        updateFileEmbedTabData("width", value); 
    };

    // Handlers Height Width Ratio Change
    const handleHeightWidthRatioChange = (e) => {
        const value = parseFloat(e.target.value);
        setHeightWidthRatio(value);
        updateFileEmbedTabData("height_width_ratio", value);
    };

    return (
         <div className="side-baar-inner-setting">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Layout</span>
                    <div class="layout-box-all">
                    <div className="card h-100 position-tabe">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="position_type" className="card-input-element d-none" value="file-viewer" onChange={handleActiveLayoutTypeChange} checked={activeLayoutType === "file-viewer"}/>
                                <div className="card card-body">
                                    <div className="content_head">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M10 7a1 1 0 0 1 1-1h42a1 1 0 0 1 1 1v50a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1V7Zm2 11a1 1 0 0 1 1-1h38a1 1 0 0 1 1 1v37a1 1 0 0 1-1 1H13a1 1 0 0 1-1-1V18Zm9-9a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm-1 4a1 1 0 0 1 1-1h30a1 1 0 1 1 0 2H21a1 1 0 0 1-1-1Zm-7-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3.465a1 1 0 0 0-.318-.732L16.038 8.27a1 1 0 0 0-.682-.27H13Z" clip-rule="evenodd"></path></svg>
                                    </div>
                                    <div class="content_sub">File Viewer</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="position_type" className="card-input-element d-none" value="grid" onChange={handleActiveLayoutTypeChange} checked={activeLayoutType === "grid"}  />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M8 10a1 1 0 0 1 1-1h19a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-9Zm10 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Zm1 2a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7Zm-9-3a1 1 0 0 1 1-1h2.356a1 1 0 0 1 .682.269l1.644 1.534a1 1 0 0 1 .318.732V17a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-5ZM8 27a1 1 0 0 1 1-1h19a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-9Zm10 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Zm1 2a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7Zm-9-3a1 1 0 0 1 1-1h2.356a1 1 0 0 1 .682.269l1.644 1.535a1 1 0 0 1 .318.73V34a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-5ZM9 43a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h19a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H9Zm10 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm-1 4a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1Zm-7-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3.465a1 1 0 0 0-.318-.731l-1.644-1.535a1 1 0 0 0-.682-.269H11Zm24-35a1 1 0 0 1 1-1h19a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H36a1 1 0 0 1-1-1v-9Zm10 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Zm1 2a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7Zm-9-3a1 1 0 0 1 1-1h2.356a1 1 0 0 1 .682.269l1.644 1.534a1 1 0 0 1 .318.732V17a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-5Zm-1 14a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h19a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H36Zm10 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm-1 4a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1Zm-7-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3.465a1 1 0 0 0-.318-.732l-1.644-1.534a1 1 0 0 0-.682-.269H38Zm-3 16a1 1 0 0 1 1-1h19a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H36a1 1 0 0 1-1-1v-9Zm10 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Zm1 2a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7Zm-9-3a1 1 0 0 1 1-1h2.356a1 1 0 0 1 .682.269l1.644 1.535a1 1 0 0 1 .318.73V51a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-5Z" clip-rule="evenodd"></path></svg>
                                    </div>
                                    <div class="content_sub">Grid</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="position_type" className="card-input-element d-none" value="list" onChange={handleActiveLayoutTypeChange} checked={activeLayoutType === "list"} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M9 9a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h46a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H9Zm10 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm-1 4a1 1 0 0 1 1-1h33a1 1 0 1 1 0 2H19a1 1 0 0 1-1-1Zm-7-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3.465a1 1 0 0 0-.318-.732l-1.644-1.534a1 1 0 0 0-.682-.269H11ZM9 26a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h46a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H9Zm10 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm-1 4a1 1 0 0 1 1-1h33a1 1 0 1 1 0 2H19a1 1 0 0 1-1-1Zm-7-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3.465a1 1 0 0 0-.318-.732l-1.644-1.534a1 1 0 0 0-.682-.269H11ZM8 44a1 1 0 0 1 1-1h46a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-9Zm10 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Zm1 2a1 1 0 1 0 0 2h33a1 1 0 1 0 0-2H19Zm-9-3a1 1 0 0 1 1-1h2.356a1 1 0 0 1 .682.269l1.644 1.535a1 1 0 0 1 .318.73V51a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-5Z" clip-rule="evenodd"></path></svg>
                                    </div>
                                    <div class="content_sub">List</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("file_icon")}>File Icon <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("preview_image")}>Preview Image <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("download_settings")}>Download Settings <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("width_height")}>Width & Height <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div> 
                </>
            )}

            {activeSettingElementsTab === "file_icon" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> File Icon</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Show File Icon</span>
                                <div className="form-group">
                                    <input
                                        type="checkbox"
                                        id="show_file_icon"
                                        className="chkbx-toggle"
                                        checked={isShowFileIcon}
                                        onChange={handleIsShowFileIconToggle}
                                    />
                                    <label htmlFor="show_file_icon"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "preview_image" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Preview Image</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Preview Image Size</span>
                                <em>{previewImageSize}px</em>
                                <div className="slider-container">
                                    <input type="range" min="25" max="200" value={previewImageSize} onChange={handlePreviewImageSizeChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "download_settings" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Download Settings</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Show Download Link</span>
                                <div className="form-group">
                                    <input
                                        type="checkbox"
                                        id="show_download_link"
                                        className="chkbx-toggle"
                                        checked={isShowDownloadLink}
                                        onChange={handleIsShowDownloadLinkToggle}
                                    />
                                    <label htmlFor="show_download_link"></label>
                                </div>
                            </div>
                        </div>
                        {Number(isShowDownloadLink) === 1 && (
                            <div className="side-baar-box-header">
                                <div className="box-header-row bubble-text">
                                    <label>Download Link Text</label>
                                    <input name="download_link_text" value={downloadLinkText} onChange={handleDownloadLinkTextChange} placeholder="Download Link Text..." type="text" />
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}

            {activeSettingElementsTab === "width_height" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Width & Height</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row bubble-text">
                                <label>Width (px, %, auto)</label>
                                <input name="width" value={width} onChange={handleWidthChange} placeholder="Width..." type="text" />
                            </div>
                        </div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Height to Width Ratio</span>
                                <em>{parseFloat(heightWidthRatio).toFixed(2)}</em>
                                <div className="slider-container">
                                    <input type="range" step="1" min="1" max="50" value={heightWidthRatio} onChange={handleHeightWidthRatioChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

        </div>
    );
};

export default LayoutTab;